import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Home } from './components/Home';
import ValueInvestingDashboard from './components/ValueInvestingDashboard';
import SavedAnalysisDashboard from './components/SavedAnalysisDashboard';
import RetroBackground from './components/RetroBackground';

function App() {
  return (
    <div className="relative min-h-screen">
      <RetroBackground />
      <div className="relative z-10">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/:ticker" element={<ValueInvestingDashboard />} />
            <Route path="/analysis/:id" element={<SavedAnalysisDashboard />} />
          </Routes>
        </BrowserRouter>
      </div>
    </div>
  );
}

export default App;